export default __webpack_public_path__ + "media/images/mailer/icon_done-b2b307df25612230f52156267fa0d5e0.png";